import ReactGA, { EventArgs } from 'react-ga';
import _ from 'lodash';

export const logEvent = (args: EventArgs) => {
  if (process.env.NODE_ENV === 'production') {
    // FIXME label (action by the end) is ITab optional value
    ReactGA.event({ ...args, action: _.isString(args.action) ? args.action : 'unknown' });
  }
};
